import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import Services from './pages/services';
import CareersPage from './pages/careers';
import ContactPage from './pages/contact';
import InsightsPage from './pages/insights';
import About from './pages/about';
import Homepage from './pages/homepage';
import PrivacyPage from "pages/privacy";
import TermsAndConditions from "pages/terms-conditions";
import VirtualAssistantPage from "pages/virtual-assistant";
import JobDetailsPage from "pages/job-details";

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<Homepage />} />
        <Route path="/services" element={<Services />} />
        <Route path="/careers" element={<NotFound />} />
        <Route path="/careers/:jobId" element={<NotFound />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/insights" element={<NotFound />} />
        <Route path="/about" element={<About />} />
        <Route path="/homepage" element={<Homepage />} />
        <Route path="/privacy-policy" element={<PrivacyPage />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/virtual-assistant" element={<VirtualAssistantPage />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
